import React from "react"
import { StoryblokComponent } from "gatsby-source-storyblok"

const BeforeContent = ({ blok }) => {
    if(typeof blok != 'undefined' && blok.length > 0){
        return(
            <div className="intro_text gs_reveal">
                {blok.map((blok) => (
                    <StoryblokComponent key={blok._uid} blok={blok} />
                ))}
            </div>
        )
    }
};
 
export default BeforeContent;
